import { render, staticRenderFns } from "./MostActiveOffersComponent.vue?vue&type=template&id=acf665ee&scoped=true&"
import script from "./MostActiveOffersComponent.vue?vue&type=script&lang=ts&"
export * from "./MostActiveOffersComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MostActiveOffersComponent.vue?vue&type=style&index=0&id=acf665ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf665ee",
  null
  
)

export default component.exports